import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Welcome from './components/welcome/Welcome.jsx';
import './App.css';

import PiwikPro from '@piwikpro/react-piwik-pro';
import Form from './components/form/From.jsx';
import Game from './components/game/Game.jsx';
import Admin from './components/admin/Admin.jsx';
import Ranking from './components/ranking/Ranking.jsx';
PiwikPro.initialize('3bbb9183-2188-4231-891a-78dcedc4b2ae', 'https://haribo.containers.piwik.pro');

function App() {

  const [shouldOpenPopup, setShouldOpenPopup] = useState(false);

  useEffect(() => {
    if (shouldOpenPopup) {
      const newWindow = window.open(
        window.location.href, 
        '_blank', 
        'width=360,height=640,resizable=no,scrollbars=no'
      );

      if (newWindow) {
        window.close();
      } else {
        alert("Le pop-up a été bloqué ! Autorisez les pop-ups et réessayez.");
      }
    }
  }, [shouldOpenPopup]);

  if(window.innerHeight >= 1080 || window.innerWidth >= 600){
    return (
      <div>
        <h1>Bienvenue</h1>
        <button onClick={() => setShouldOpenPopup(true)}>
          Ouvrir l'application en mode mobile
        </button>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path='/' Component={Welcome} />
        <Route path='/form' Component={Form} />
        <Route path='/game' Component={Game} />
        <Route path='/ranking' Component={Ranking} />
        <Route path='/admin/:pass' Component={Admin} />
      </Routes>
    </Router>
  );
}

export default App;